/* eslint-disable no-underscore-dangle,no-useless-constructor,no-console,
graphql/template-strings */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
// adopt
import { adopt } from 'react-adopt';
// graphQL
import gql from 'graphql-tag';
// global variables
import {
  defaultNumberOfRows as DEFAULT_NUMBER_OF_ROWS,
  inboxTabValues,
  adStatus,
} from 'config';
// our components
import { Query, Mutation } from 'components/common/Query';
import { CustomPageInfo as PageInfo } from 'components/common/Paginator';
import { bulkUpdate } from 'helpers/updateMutationsHelper';
import ReviewQueueList from 'components/ReviewQueue/List/List';
import qs, { getQueryString } from 'helpers/queryStrings';
import RouterContext from 'helpers/routerContext';

/**
 * Query to fetch ads from api
 */
export const ADS_QUERY = gql`
  query AdsListReviewQueue(
    $first: Int
    $after: String
    $last: Int
    $before: String
    $statusIn: [String]
    $updatedOnGte: String
    $updatedOnLte: String
  ) {
    ads(
      first: $first
      after: $after
      last: $last
      before: $before
      statusIn: $statusIn
      updatedOnGte: $updatedOnGte
      updatedOnLte: $updatedOnLte
      sort: [
        { field: is_auto, order: desc }
        { field: updated_on, order: desc }
      ]
    ) @connection(key: "ads_review_queue") {
      pageInfo {
        ...PaginatorCustomPageInfo
      }
      edges {
        node {
          id
          title
          price
          readyImages {
            id
            urls {
              high
              thumb
            }
          }
          subcategory {
            id
            title
            parentCategory {
              id
              title
            }
          }
          isAuto
          matchedRules
          updatedOn
          flagCount
          updateCount
          botScoreUpdate
          botScoreInsert
          ipInsert
          ipUpdate
          countryInsert
          countryUpdate
        }
      }
    }
  }
  ${PageInfo}
`;

/**
 * Mutation to publish ads
 */
export const PUBLISH_ADS_MUTATION = gql`
  mutation($ids: [ID]!) {
    publishAd(input: { ids: $ids }) {
      successIds
      errors {
        field
        messages
      }
    }
  }
`;

/**
 * Mutation to publish ads
 */
export const UNPUBLISH_ADS_MUTATION = gql`
  mutation($ids: [ID]!) {
    unPublishAd(input: { ids: $ids }) {
      successIds
      errors {
        field
        messages
      }
    }
  }
`;

/**
 * Mutation to change ad category
 */
export const CHANGE_AD_CATEGORY_MUTATION = gql`
  mutation($id: ID!, $subcategoryId: ID!) {
    changeAdCategory(input: { id: $id, subcategory: $subcategoryId }) {
      ad {
        id
      }
      errors {
        field
        messages
      }
    }
  }
`;

/**
 * Query to fetch ads in TO_REVIEW from api
 */
export const ADS_TO_REVIEW_QUERY = gql`
  query adsToReviewCount(
    $fromToday: DateTime!
    $toToday: DateTime!
    $fromYesterday: DateTime!
    $toYesterday: DateTime!
    $fromLastWeek: DateTime!
    $toLastWeek: DateTime!
    $fromPrevious: DateTime!
    $toPrevious: DateTime!
  ) {
    to_review_today: adsToReviewCount(fromDate: $fromToday, toDate: $toToday)

    to_review_yesterday: adsToReviewCount(
      fromDate: $fromYesterday
      toDate: $toYesterday
    )

    to_review_last_week: adsToReviewCount(
      fromDate: $fromLastWeek
      toDate: $toLastWeek
    )

    to_review_previous: adsToReviewCount(
      fromDate: $fromPrevious
      toDate: $toPrevious
    )
  }
`;

/**
 * @class
 * @description ReviewQueue List Component
 * @augments Component
 */
class ReviewQueueListContainer extends Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    const { initialFilters } = props;
    const {
      currentInbox,
      direction,
      cursor,
      numberOfRowsSelected,
    } = initialFilters;
    const inboxTabValuesToday = this.getInboxDateRange(inboxTabValues.TODAY);
    const inboxTabValuesYesterday = this.getInboxDateRange(
      inboxTabValues.YESTERDAY,
    );
    const inboxTabValuesLastWeek = this.getInboxDateRange(
      inboxTabValues.LAST_WEEK,
    );
    const inboxTabValuesPrevious = this.getInboxDateRange(
      inboxTabValues.PREVIOUS,
    );
    this.state = {
      numberOfRowsSelected:
        parseInt(numberOfRowsSelected, 0) || DEFAULT_NUMBER_OF_ROWS,
      currentInbox: currentInbox || inboxTabValues.TODAY,
      pagination: { direction: direction || null, cursor: cursor || undefined },
      itemProcessing: [],
      failedIds: [],
      showNotification: false,
      dateInboxFilters: {
        fromToday: inboxTabValuesToday.fromDate,
        toToday: inboxTabValuesToday.toDate,
        fromYesterday: inboxTabValuesYesterday.fromDate,
        toYesterday: inboxTabValuesYesterday.toDate,
        fromLastWeek: inboxTabValuesLastWeek.fromDate,
        toLastWeek: inboxTabValuesLastWeek.toDate,
        fromPrevious: inboxTabValuesPrevious.fromDate,
        toPrevious: inboxTabValuesPrevious.toDate,
      },
    };
    this.Compose = adopt({
      mutateAdPublish: this.adPublish,
      mutateAdUnPublish: this.adUnPublish,
      mutateAdChangeCategory: this.adChangeCategory,
      queryAds: this.listAds,
      queryCountInbox: this.toReviewCountInbox,
    });
    this.fetchMoreAds = () => {};
    this.fetchMoreCountInbox = () => {};
  }

  /**
   * @description
   * Get inbox date range.
   *
   * @param {string} inbox - Inbox tab.
   * @returns {Object} Date from inbox tab values.
   */
  getInboxDateRange = inbox => {
    switch (inbox) {
      case inboxTabValues.TODAY:
        return {
          fromDate: moment()
            .startOf('day')
            .format(),
          toDate: moment().format(),
        };
      case inboxTabValues.YESTERDAY:
        return {
          fromDate: moment()
            .subtract(1, 'd')
            .startOf('day')
            .format(),
          toDate: moment()
            .subtract(1, 'd')
            .endOf('day')
            .format(),
        };
      case inboxTabValues.LAST_WEEK:
        return {
          fromDate: moment()
            .subtract(7, 'days')
            .startOf('day')
            .format(),
          toDate: moment()
            .subtract(2, 'd')
            .endOf('day')
            .format(),
        };
      case inboxTabValues.PREVIOUS:
        return {
          fromDate: moment()
            .subtract(3, 'months')
            .startOf('day')
            .format(),
          toDate: moment()
            .subtract(7, 'days')
            .startOf('day')
            .format(),
        };
      default:
        return null;
    }
  };

  /**
   * @description
   * Calculate date filters based on current selected inbox.
   */
  getDateFilters = () => {
    const { currentInbox } = this.state;
    const currentInboxTabValues = this.getInboxDateRange(currentInbox);
    return {
      updatedOnGte: currentInboxTabValues
        ? currentInboxTabValues.fromDate
        : undefined,
      updatedOnLte: currentInboxTabValues
        ? currentInboxTabValues.toDate
        : undefined,
    };
  };

  /**
   * @description
   * Query callback to compose with mutations.
   *
   * @param {*} render - Query's render props.
   * @returns {*} Query component.
   */
  listAds = ({ render }) => {
    const { pagination, numberOfRowsSelected } = this.state;
    const paginationVariables =
      !pagination.direction || pagination.direction === 'NEXT'
        ? {
            first: numberOfRowsSelected,
            after: pagination.cursor,
          }
        : {
            last: numberOfRowsSelected,
            before: pagination.cursor,
          };
    const dateFilters = this.getDateFilters();
    return (
      <Query
        query={ADS_QUERY}
        variables={{
          ...paginationVariables,
          ...dateFilters,
          statusIn: [adStatus.TO_REVIEW],
        }}
        notifyOnNetworkStatusChange
        fetchPolicy="cache-and-network"
      >
        {({ data, loading, fetchMore }) => {
          this.fetchMoreAds = fetchMore;
          return render({ data, loading, fetchMore });
        }}
      </Query>
    );
  };

  /**
   * @description
   * Query callback to compose with mutations.
   *
   * @param {*} render - Query's render props.
   * @returns {*} Query component.
   */
  toReviewCountInbox = ({ render }) => {
    const { dateInboxFilters } = this.state;
    return (
      <Query
        query={ADS_TO_REVIEW_QUERY}
        variables={{ ...dateInboxFilters }}
        notifyOnNetworkStatusChange
        fetchPolicy="cache-and-network"
      >
        {({ data, loading, fetchMore }) => {
          this.fetchMoreCountInbox = fetchMore;
          return render({ data, loading, fetchMore });
        }}
      </Query>
    );
  };

  /**
   * @description
   * Mutation publish callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  adPublish = ({ render }) => {
    const { itemProcessing } = this.state;
    return (
      <Mutation
        mutation={PUBLISH_ADS_MUTATION}
        onCompleted={this.mutationCompleted('publishAd', itemProcessing)}
        update={(cache, { data: { publishAd } }) => {
          const data = {
            status: adStatus.PUBLISHED_BY_MODERATOR,
            __typename: 'AdminAdType',
          };

          bulkUpdate(
            cache,
            'AdminAdType',
            'Publish',
            'status',
            data,
            publishAd.successIds,
          );

          const variables = { last: publishAd.successIds.length };
          const { ads } = cache.readQuery({
            query: ADS_QUERY,
          });

          const newEdges = ads.edges.filter(
            edge => publishAd.successIds.indexOf(edge.node.id) === -1,
          );

          cache.writeQuery({
            query: ADS_QUERY,
            data: {
              ads: {
                ...ads,
                edges: newEdges,
              },
            },
          });

          this.fetchMoreAds({
            variables,
            updateQuery: this.updateQuery,
          });
        }}
      >
        {handleAdPublish => render({ handleAdPublish })}
      </Mutation>
    );
  };

  /**
   * @description
   * Mutation unpublish callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  adUnPublish = ({ render }) => {
    const { itemProcessing } = this.state;
    return (
      <Mutation
        mutation={UNPUBLISH_ADS_MUTATION}
        onCompleted={this.mutationCompleted('unPublishAd', itemProcessing)}
        update={(cache, { data: { unPublishAd } }) => {
          const data = {
            status: adStatus.UNPUBLISHED_BY_MODERATOR,
            __typename: 'AdminAdType',
          };

          bulkUpdate(
            cache,
            'AdminAdType',
            'Unpublish',
            'status',
            data,
            unPublishAd.successIds,
          );

          const variables = { last: unPublishAd.successIds.length };
          const { ads } = cache.readQuery({
            query: ADS_QUERY,
          });

          const newEdges = ads.edges.filter(
            edge => unPublishAd.successIds.indexOf(edge.node.id) === -1,
          );

          cache.writeQuery({
            query: ADS_QUERY,
            data: {
              ads: {
                ...ads,
                edges: newEdges,
              },
            },
          });

          this.fetchMoreAds({
            variables,
            updateQuery: this.updateQuery,
          });
        }}
      >
        {handleAdUnPublish => render({ handleAdUnPublish })}
      </Mutation>
    );
  };

  /**
   * @description
   * Mutation to change ad category.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  adChangeCategory = ({ render }) => (
    <Mutation mutation={CHANGE_AD_CATEGORY_MUTATION}>
      {handleAdChangeCategory => render({ handleAdChangeCategory })}
    </Mutation>
  );

  /**
   * @description
   * OnComplete delete mutation.
   *
   * @param {Object} field - Target field of mutation.
   * @param {Object} itemProcessing - Ids of items that is processing.
   * @returns {undefined} - No returns value.
   */
  mutationCompleted = (field, itemProcessing) => async data => {
    const failedIds = itemProcessing.filter(
      item => !data[field].successIds.includes(item),
    );
    this.setState({
      itemProcessing: [],
      failedIds,
      showNotification: failedIds.length > 0,
    });
    this.fetchMoreCountInbox({
      updateQuery: (_, { fetchMoreResult }) => fetchMoreResult,
    });
  };

  /**
   * @description
   * Query helpful function to update query's result.
   *
   * @param {Object} previousResult - Latest Query result.
   * @param {Object} options - UpdateQuery options.
   * @returns {Object} New or Previous query's result.
   */
  updateQuery = (previousResult, options) => {
    const { pageInfo, edges: newEdges } = options.fetchMoreResult.ads;
    if (newEdges.length !== 0) {
      return {
        ads: {
          __typename: previousResult.ads.__typename,
          edges: [...previousResult.ads.edges, ...newEdges],
          pageInfo: {
            ...previousResult.ads.pageInfo,
            hasNextPage: pageInfo.hasNextPage,
          },
        },
      };
    }
    return previousResult;
  };

  /**
   * @description
   * Change inbox tab.
   *
   * @param {string} tab - Inbox tab.
   */
  handleChangeInbox = tab => {
    const history = this.context;
    const currentInbox = tab.value;
    this.setState({
      currentInbox,
    });
    const currentLocation = history.location.pathname;
    const parsed = getQueryString(history);
    const stringified = qs.stringify({ ...parsed, currentInbox });
    history.push({ pathname: currentLocation, search: stringified });
  };

  /**
   * @description
   * Change number of rows selected.
   *
   @param {number} selectedItem - New number of rows selected.
   */
  handleChangeNumberOfRows = selectedItem => {
    const history = this.context;
    this.setState({
      numberOfRowsSelected: selectedItem,
      pagination: { direction: null, cursor: undefined },
    });
    const currentLocation = history.location.pathname;
    const parsed = getQueryString(history);
    const stringified = qs.stringify({
      ...parsed,
      numberOfRowsSelected: selectedItem,
      direction: undefined,
      cursor: undefined,
    });
    history.push({ pathname: currentLocation, search: stringified });
  };

  /**
   * @description
   * Fetch more rows when user change page.
   *
   * @param {Object} paginatorVariables - Pagination query's variables.
   */
  handleChangePage = ({ direction, cursor }) => {
    const history = this.context;
    this.setState({ pagination: { direction, cursor } });
    const currentLocation = history.location.pathname;
    const parsed = getQueryString(history);
    const stringified = qs.stringify({
      ...parsed,
      direction,
      cursor,
    });
    history.push({ pathname: currentLocation, search: stringified });
  };

  /**
   * @description
   * Refresh the list.
   * @returns {Function} - Fetch More function.
   */
  handleRefresh = () => {
    this.fetchMoreAds({
      updateQuery: (_, { fetchMoreResult }) => fetchMoreResult,
    });
    this.fetchMoreCountInbox({
      updateQuery: (_, { fetchMoreResult }) => fetchMoreResult,
    });
  };

  /**
   * @description
   * Close notification.
   * @returns {undefined} - No returns value.
   */
  handleCloseNotification = () => {
    this.setState({ showNotification: false });
  };

  /**
   * @description
   * Render ReviewQueueList component.
   *
   * @returns {undefined} - No returns.
   */
  render() {
    const {
      numberOfRowsSelected,
      pagination,
      currentInbox,
      itemProcessing,
      failedIds,
      showNotification,
    } = this.state;
    return (
      <this.Compose>
        {({
          mutateAdPublish: { handleAdPublish },
          mutateAdUnPublish: { handleAdUnPublish },
          mutateAdChangeCategory: { handleAdChangeCategory },
          queryCountInbox: { data: dataCountInbox },
          queryAds: { loading, data },
        }) => (
          <React.Fragment>
            <ReviewQueueList
              data={data}
              dataCountInbox={
                dataCountInbox && Object.keys(dataCountInbox).length > 0
                  ? dataCountInbox
                  : {}
              }
              adPublish={items => {
                this.setState({
                  itemProcessing: [...itemProcessing, ...items],
                  failedIds: [],
                });
                handleAdPublish({ variables: { ids: items } });
              }}
              adUnPublish={items => {
                this.setState({
                  itemProcessing: [...itemProcessing, ...items],
                  failedIds: [],
                });
                handleAdUnPublish({ variables: { ids: items } });
              }}
              adApplyRuleAndPublish={(items, subcategoryId) => {
                this.setState({
                  itemProcessing: [...itemProcessing, ...items],
                  failedIds: [],
                });
                if (!subcategoryId || !items || items.length === 0) {
                  handleAdPublish({ variables: { ids: items } });
                  return;
                }
                handleAdChangeCategory({
                  variables: {
                    id: `${items[0]}`,
                    subcategoryId: `${subcategoryId}`,
                  },
                })
                  .then(({ data: mutationData }) => {
                    if (
                      mutationData &&
                      mutationData.changeAdCategory &&
                      mutationData.changeAdCategory.errors
                    ) {
                      this.setState({
                        itemProcessing: [],
                        failedIds: items,
                        showNotification: true,
                      });
                      return;
                    }
                    handleAdPublish({ variables: { ids: items } });
                  })
                  .catch(() => {
                    this.setState({
                      itemProcessing: [],
                      failedIds: items,
                      showNotification: true,
                    });
                  });
              }}
              changePage={paginationVariables => {
                this.handleChangePage(paginationVariables);
              }}
              numberOfRowsSelected={numberOfRowsSelected}
              changeNumberOfRows={numberOfRows => {
                this.handleChangeNumberOfRows(numberOfRows);
              }}
              changeInbox={tab => {
                this.handleChangeInbox(tab);
              }}
              refresh={this.handleRefresh}
              currentInbox={currentInbox}
              paginationDirection={pagination.direction}
              fullLoading={loading}
              itemProcessing={itemProcessing}
              loading={Object.keys(data).length === 0}
              failedIds={failedIds}
              showNotification={showNotification}
              closeNotification={this.handleCloseNotification}
            />
          </React.Fragment>
        )}
      </this.Compose>
    );
  }
}

/**
 * ReviewQueueListContainer PropTypes
 * @param initialFilters - prop initial Filters to apply
 */

ReviewQueueListContainer.propTypes = {
  initialFilters: PropTypes.shape({}).isRequired,
};

export default ReviewQueueListContainer;
